<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 18" height="17" enable-background="new 0 0 18 18" xml:space="preserve">
<polygon fill="currentColor" points="6,2 6,4 7,4 7,3 11,3 11,6 14,6 14,11 13,11 13,12 15,12 15,5 12,2 "/>
<path fill="currentColor" d="M12,8L9,5H3v10h9V8z M4,14V6h4v3h3v5H4z"/>
</svg>
